import { CasumoLoaderIcon } from '../assets/icons';

const Loader = () =>
  <span
    className="animate-spin h-full flex justify-center items-center w-md"
  >
    <CasumoLoaderIcon width={20} height={20} />
  </span>;

export default Loader;
